/*8/1/26*/
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Navbar.css";

export default function Navbar() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const role = user?.role;


  const handleLogout = () => {
    localStorage.removeItem("user");
   // localStorage.removeItem("loggedUser");
    navigate("/login", { replace: true });
  };



  
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white sticky-top shadow-sm py-1">
      <div className="container">

        {/* BRAND WITH LOGO */}
        <Link to="/" className="navbar-brand d-flex align-items-center gap-2">
          <img
            src="/images/logosmall.jpg"
            alt="Logo"
            className="navbar-logo"
          />
          <span className="navbar-title" >
            NIVARA AGRO TOURISM<span className="dot">.</span>
          </span>
        </Link>

        {/* MOBILE TOGGLE */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarMenu"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarMenu">
          <ul className="navbar-nav ms-auto align-items-center">
            <li className="nav-item">
              <Link className="nav-link fw-semibold px-3" to="/">Home</Link>
            </li>
            <li className="nav-item">
    <Link className="nav-link fw-semibold px-3" to="/about">About Us</Link>
  </li>
            

            {role === "ADMIN" ? (
              <>
                <li className="nav-item">
                  <Link className="nav-link fw-semibold px-3" to="/admin/manage-rooms">Rooms</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link fw-semibold px-3" to="/admin/bookings">Bookings</Link>
                </li>
              <li className="nav-item">
                  <Link className="nav-link fw-semibold px-3" to="/admin/dashboard">Dashboard</Link>
                </li>

              </>
            ) : (
              <>
                <li className="nav-item">
                <Link className="nav-link fw-semibold px-3" to="/rooms">Book Room</Link>
                </li>

                <li className="nav-item">
                  <Link className="nav-link fw-semibold px-3" to="/activity">Activities</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link fw-semibold px-3" to="/services">Services</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link fw-semibold px-3" to="/contact">Contact</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link fw-semibold px-3" to="/register">Register</Link>
                </li>
              </>
            )}

            {role === "USER" && (
              <li className="nav-item">
                <Link className="nav-link fw-semibold px-3" to="/booking-history">
                  My Bookings
                </Link>
              </li>
            )}
          </ul>

          <div className="ms-3">
            {!user ? (
              <Link className="btn btn-outline-dark rounded-0 fw-bold px-3" to="/login">
                LOGIN
              </Link>
            ) : (
              <button
                onClick={handleLogout}
                className="btn btn-danger rounded-0 fw-bold px-3"
              >
                LOGOUT
              </button>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}
